/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var ActiveCards, App, Game, GameList, Lobby, Login, Menu, PropTypes, PureRenderMixin, React, Redux, Result, cardActions, connect, gameActions, mapDispatchToProps, mapStateToProps, userActions;

React = require('react');

PropTypes = React.PropTypes;

Redux = require('redux');

connect = require('react-redux').connect;

PureRenderMixin = require('react-addons-pure-render-mixin');

cardActions = require('./actions/cards');

userActions = require('./actions/user');

gameActions = require('./actions/games');

ActiveCards = require('./active-cards');

GameList = require('./game-list');

Login = require('./login');

Lobby = require('./lobby');

Game = require('./game');

Menu = require('./menu');

Result = require('./result');

App = React.createClass({
  mixins: [PureRenderMixin],
  displayName: 'App',
  render: function() {
    var el, game, menu, ref, ref1;
    game = this.props.user.gameId ? this.props.games.items[this.props.user.gameId] : null;
    if (game && game.state === 'running') {
      el = React.createElement(Game, {
        "game": game,
        "user": this.props.user,
        "actions": this.props.actions,
        "cards": this.props.cards
      });
    } else if (game && game.state === 'over') {
      el = React.createElement(Result, {
        "game": game,
        "user": this.props.user,
        "actions": this.props.actions,
        "cards": this.props.cards
      });
    } else if (game) {
      el = React.createElement(Lobby, {
        "game": game,
        "user": this.props.user,
        "actions": this.props.actions
      });
    } else if ((ref = this.props.user.data) != null ? ref.id : void 0) {
      el = React.createElement(GameList, {
        "games": this.props.games,
        "actions": this.props.actions
      });
    } else {
      el = React.createElement(Login, {
        "user": this.props.user,
        "actions": this.props.actions
      });
    }
    if ((ref1 = this.props.user.data) != null ? ref1.id : void 0) {
      menu = React.createElement(Menu, {
        "actions": this.props.actions,
        "user": this.props.user
      });
    }
    return React.createElement("div", null, menu, el);
  }
});

App.propTypes = {
  cards: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  games: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

mapStateToProps = function(state) {
  return {
    cards: state.cards,
    games: state.games,
    user: state.user
  };
};

mapDispatchToProps = function(dispatch) {
  var allActions;
  allActions = Object.assign({}, cardActions, userActions, gameActions);
  return {
    actions: Redux.bindActionCreators(allActions, dispatch)
  };
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(App);


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "app.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/app.cjsx
 ** module id = 239
 ** module chunks = 0
 **/